import React, { useState, useEffect } from 'react';
import './CampaignAddOn.css';
import { fetchAddOns, submitCampaignType } from '../api/mockApi';
import BottomSheetImg from '../images/bottom-sheet.svg';

const CampaignAddOn = ({ onNext }) => {
  const [addOns, setAddOns] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  const [loading, setLoading] = useState(true);
  const [bottomSheetInfo, setBottomSheetInfo] = useState(null);

  useEffect(() => {
    fetchAddOns().then((data) => {
      setAddOns(data);
      setLoading(false);
    });
  }, []);

  const handleSelect = (type) => {
    setSelectedType(type);
    submitCampaignType(type);
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="campaign-addon-container">
      <h2>Hai, <span className="highlight">#OrangBaik</span>!</h2>
      <p>Kamu ingin menggalang dana untuk...</p>
      <div className="card-list">
        <div className={`card ${selectedType==='sakit' ? 'selected' : ''}`}>
          <div className="card-header">
            <span className="icon medical">+</span>
            <div>
              <div className="card-title">Galang dana bantuan orang sakit</div>
              <div className="card-desc">Khusus biaya pengobatan atau perawatan penyakit tertentu.</div>
            </div>
          </div>
          <button
            className="main-btn"
            onClick={() => {
              handleSelect('sakit');
              if (typeof onNext === 'function') onNext();
            }}
          >
            Buat galang dana orang sakit
          </button>
          <div className="addon-list">
            <div className="addon-title">Gratis layanan tambahan*</div>
            {addOns.map((addon) => (
              <div className="addon-item" key={addon.id}>
                <span className="icon ambulance">🚑</span>
                {addon.name}
                <span
                  className="icon info"
                  title={addon.info}
                  onClick={() => setBottomSheetInfo(addon)}
                  tabIndex={0}
                  role="button"
                  aria-label={`Info ${addon.name}`}
                  style={{outline: 'none'}}
                >i</span>
              </div>
            ))}
            <div className="addon-note">
              <span className="note-star">*</span>
              Kamu bisa memilih tambahan layanan saat mengisi <b>Riwayat Medis</b>, biaya otomatis diambil dari donasi kamu yang terkumpul dan sesuai dengan ketentuan yang berlaku.
            </div>
          </div>
        </div>
        <div className={`card ${selectedType==='lainnya' ? 'selected' : ''}`}>
          <div className="card-header">
            <span className="icon heart">❤</span>
            <div>
              <div className="card-title">Galang dana bantuan lainnya</div>
              <div className="card-desc">Untuk bantuan pendidikan, kemanusiaan, bencana alam, dsb.</div>
            </div>
          </div>
          <button className="main-btn" onClick={() => handleSelect('lainnya')}>
            Buat galang bantuan lainnya
          </button>
        </div>
      </div>
    {/* Bottom Sheet Popup */}
    {bottomSheetInfo && (
      <div className="bottom-sheet-overlay" onClick={() => setBottomSheetInfo(null)}>
        <div className="bottom-sheet" onClick={e => e.stopPropagation()}>
          <div className="sheet-header">
            <button className="sheet-back" onClick={() => setBottomSheetInfo(null)} aria-label="Tutup">←</button>
            <span className="sheet-title">Penjemputan ambulance</span>
          </div>
          <div className="sheet-illustration">
            <img src={BottomSheetImg} alt="Penjemputan ambulance" className="img-placeholder" />
          </div>
          <div className="sheet-section-title">Tentukan lokasi dan waktu penjemputan.</div>
          <ul className="sheet-list">
            <li>Membantu kamu yang butuh transportasi khusus.</li>
            <li>Caranya mudah karena tinggal tentukan lokasi, anti ribet pembayaran.</li>
            <li>Langsung dipotong dari donasi yang sudah terkumpul.</li>
            <li>Transparan, semua bukti potong akan di sampaikan dengan terbuka.</li>
            <li>Biaya ambulance mulai dari Rp 300 ribu/penjemputan.</li>
          </ul>
          <button className="sheet-btn" onClick={() => setBottomSheetInfo(null)}>Mengerti</button>
        </div>
      </div>
    )}
  </div>
  );
};

export default CampaignAddOn;
